module.exports = __webpack_public_path__ + "img/kg.f4257dfe.svg";